"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortSelector = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/overlay/select/select");
const SORT_OPTIONS = [
    { label: '최신순', value: 'latest' },
    { label: '오래된순', value: 'oldest' },
];
let SortSelector = class SortSelector extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.value = 'latest';
    }
    render() {
        return (0, lit_1.html) `
      <mm-select
        aria-label="정렬"
        .value=${this.value}
        .options=${SORT_OPTIONS}
        @change=${this.handleSelectChange}
      ></mm-select>
    `;
    }
    // select가 트리거 라벨을 스스로 소유하므로, 여기서는 외부에 노출하는 value 프로퍼티만 동기화한다.
    handleSelectChange(e) {
        this.value = e.detail.value;
    }
};
SortSelector.styles = (0, lit_1.css) `
    :host {
      display: inline-flex;
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String })
], SortSelector.prototype, "value", void 0);
SortSelector = __decorate([
    (0, decorators_js_1.customElement)('mm-sort-selector')
], SortSelector);
exports.SortSelector = SortSelector;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic29ydC1zZWxlY3Rvci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInNvcnQtc2VsZWN0b3IudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsNkJBQTJDO0FBQzNDLHFEQUEyRDtBQUkzRCw4Q0FBMkM7QUFJM0MsTUFBTSxZQUFZLEdBQWlCO0lBQ2pDLEVBQUUsS0FBSyxFQUFFLEtBQUssRUFBRSxLQUFLLEVBQUUsUUFBUSxFQUFFO0lBQ2pDLEVBQUUsS0FBSyxFQUFFLE1BQU0sRUFBRSxLQUFLLEVBQUUsUUFBUSxFQUFFO0NBQ25DLENBQUE7QUFHTSxJQUFNLFlBQVksR0FBbEIsTUFBTSxZQUFhLFNBQVEsZ0JBQVU7SUFBckM7O1FBTXVCLFVBQUssR0FBYyxRQUFRLENBQUE7SUFpQnpELENBQUM7SUFmQyxNQUFNO1FBQ0osT0FBTyxJQUFBLFVBQUksRUFBQTs7O2lCQUdFLElBQUksQ0FBQyxLQUFLO21CQUNSLFlBQVk7a0JBQ2IsSUFBSSxDQUFDLGtCQUFrQjs7S0FFcEMsQ0FBQTtJQUNILENBQUM7SUFFRCw4REFBOEQ7SUFDdEQsa0JBQWtCLENBQUMsQ0FBYztRQUN2QyxJQUFJLENBQUMsS0FBSyxHQUFHLENBQUMsQ0FBQyxNQUFNLENBQUMsS0FBa0IsQ0FBQTtJQUMxQyxDQUFDOztBQXJCTSxtQkFBTSxHQUFHLElBQUEsU0FBRyxFQUFBOzs7O0dBSWxCLENBQUE7QUFDMkI7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDOzJDQUE0QjtBQU41QyxZQUFZO0lBRHhCLElBQUEsNkJBQWEsRUFBQyxrQkFBa0IsQ0FBQztHQUNyQixZQUFZLENBdUJ4QjtBQXZCWSxvQ0FBWSJ9